module.exports = __webpack_public_path__ + "static/media/history.cb75508b.png";